import classNames from "classnames";
import React from "react";

import styles from "./DesktopFilterItem.module.scss";

interface Props {
  filterLabel: string;
  filterSelected?: boolean;
  clearButtonClick?: () => void;
  halfWidth?: boolean;
  flexStart?: boolean;
  withClearButton?: boolean;
}

class DesktopFilterItem extends React.PureComponent<Props> {
  public render() {
    const {
      children,
      filterLabel,
      filterSelected,
      clearButtonClick,
      halfWidth = false,
      flexStart = false,
      withClearButton = false,
    } = this.props;

    const containerClassName = classNames(styles.singleFilterContainer, {
      [styles.twoFiltersContainer]: halfWidth,
      [styles.flexStartRow]: flexStart,
    });

    return (
      <div className={containerClassName}>
        <p className={styles.filterLabel}>{filterLabel}</p>
        <div className={styles.inputsRow}>{children}</div>
        {withClearButton ? (
          <p
            className={
              filterSelected
                ? styles.activeButtonText
                : styles.disabledButtonText
            }
            onClick={clearButtonClick}
          >
            クリア
          </p>
        ) : null}
      </div>
    );
  }
}

export default DesktopFilterItem;
